var map = {
	"./albm.png": 50,
	"./background.jpg": 10,
	"./contact/fb.png": 14,
	"./contact/gh.png": 5,
	"./contact/li.png": 13,
	"./contact/tw.png": 51,
	"./down.png": 11,
	"./drcall.jpg": 12,
	"./exp/android.png": 16,
	"./exp/c1.png": 17,
	"./exp/c2.png": 18,
	"./exp/c3.png": 19,
	"./exp/cf.png": 20,
	"./exp/cs.png": 21,
	"./exp/google.png": 22,
	"./exp/health.png": 23,
	"./exp/solar.png": 24,
	"./exp/tt.png": 25,
	"./exp/vertigo.png": 26,
	"./favicon.ico": 8,
	"./logo.png": 7,
	"./menu.png": 9,
	"./proj/dashboard.jpg": 27,
	"./proj/game.jpg": 28,
	"./proj/pathfinding.png": 29,
	"./proj/rendezvous.jpg": 30,
	"./proj/vertigo.jpg": 31,
	"./uva.png": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;